import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const e = "lang", t = `${e}/available_languages`;
class g extends s {
  /**
   * Fetches the list of available languages from the API.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/lang/available_languages`
   *
   * @returns {Promise<Language[]>} A promise resolving to an array of language objects.
   */
  getAvailableLanguages = async () => {
    const { data: a } = await this.get(t);
    return a;
  };
}
export {
  t as LANG_AVAILABLE_LANGUAGES_URI,
  e as LANG_RESOURCE_URI,
  g as Lang
};
